<template>
  <svg class="_component-icon-svg" @click="$emit('click')" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 10C1 10 3 16 10 16C17 16 19 10 19 10C19 10 17 4 10 4C3 4 1 10 1 10ZM3.18854 10C3.18924 10.0013 3.18994 10.0027 3.19064 10.004C3.42664 10.4511 3.80203 11.0515 4.34931 11.6486C5.41308 12.809 7.15339 14 10 14C12.8466 14 14.5869 12.809 15.6507 11.6486C16.198 11.0515 16.5734 10.4511 16.8094 10.004C16.8101 10.0027 16.8108 10.0013 16.8115 10C16.8108 9.99868 16.8101 9.99735 16.8094 9.99602C16.5734 9.54888 16.198 8.94848 15.6507 8.35145C14.5869 7.19097 12.8466 6 10 6C7.15339 6 5.41308 7.19097 4.34931 8.35145C3.80203 8.94848 3.42664 9.54888 3.19064 9.99602C3.18994 9.99735 3.18924 9.99867 3.18854 10Z"
      :style="componentStyle"
    />
    <circle cx="10" cy="10" r="3" :style="componentStyle" />
  </svg>
</template>

<script>
/**
 * @module User 关闭组件
 */
export default {
  name: 'User',
  /**
   * @prop {String} color 颜色
   */
  props: {
    color: {
      type: String,
      default: '#17181A'
    }
  },
  /**
   * @member {Object} componentStyle 组件style
   */
  computed: {
    componentStyle() {
      return {
        fill: this.color
      };
    },
    strokeColor() {
      return this.color === 'none' ? '#494A4D' : this.color;
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
